// extracted by mini-css-extract-plugin
module.exports = {"main":"valuation-update-module--main--aq-9L"};